import { Navigate } from 'react-router-dom';

export function GanttRedirectPage() {
  return <Navigate to="/gantt" replace />;
}
